import Post from "./post";

export default class Lead extends Post {

    type = "leadads";


}